(ns ui.view.card.counterparty-diligence-answers.event
  (:require
   [re-frame.core :as rf]
   [ui.view.counterparty-diligence.responder-form.event :as responder-form-event]
   [ui.view.card.counterparty-diligence-answers.model :as model]
   [ui.view.card.event :refer [after-fetch-card-data-success-fx]]
   [ui.view.card.model :as common-model]
   [common.schema.entities.counterparty-diligence.templates.registry :as cd-template-registry]
   [frontend.state.current-session :as session]
   [common.localization :as loc]))

(defmethod after-fetch-card-data-success-fx
  :card.type/counterparty-diligence-answers
  [ctx]
  [[:dispatch [::initialize-form-state ctx]]])

(def inject-tenant-interceptor
  (rf/->interceptor
   {:id     ::inject-tenant
    :before (fn [args]
              (let [tenant @session/tenant]
                (assoc-in args [:coeffects :tenant] tenant)))}))

(rf/reg-event-fx
 ::initialize-form-state
 [rf/trim-v
  inject-tenant-interceptor]
 (fn [{:keys [db tenant]} [{:keys [entity-id card-state-path]}]]
   (let [entities (common-model/get-entities db card-state-path)
         counterparty-diligence (get entities entity-id)
         latest-process (->> counterparty-diligence
                             :counterparty-diligence/processes
                             (mapv #(get entities %))
                             (remove nil?)
                             (sort-by :common/created-on)
                             last)
         answers (:counterparty-diligence-process/answers latest-process)
         template (cd-template-registry/resolve-template counterparty-diligence)
         e-signature-required? (-> counterparty-diligence
                                   :counterparty-diligence/e-signature-required
                                   (= :yes))
         date-format (or (:tenant/date-format tenant) (loc/tr :date-format))]
     {:fx [[:dispatch [::responder-form-event/initialize
                       {:state-path (model/form-state-full-path card-state-path)
                        :process-id (:db/id latest-process)
                        :template template
                        :answers answers
                        :tenant-user-access? true
                        :e-signature-required? e-signature-required?
                        :attachments-by-id entities
                        :view-mode :form-edit-mode
                        :date-format date-format}]]]})))
